import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, Briefcase, FileText, UserCog, ListChecks, LogOut, User } from "lucide-react";
import { clearAuth, getUser } from "../lib/api";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_f8301de4-2106-462d-b07e-224b65c4a393/artifacts/n5bqno46_text.png";

const links = [
  { to: "/dashboard", icon: LayoutDashboard, label: "Dashboard", id: "nav-dashboard" },
  { to: "/clientes", icon: Users, label: "Clientes", id: "nav-clientes" },
  { to: "/servicos", icon: Briefcase, label: "Serviços", id: "nav-servicos" },
  { to: "/notas-encomenda", icon: FileText, label: "Notas de Encomenda", id: "nav-notas" },
  { to: "/utilizadores", icon: UserCog, label: "Utilizadores", id: "nav-utilizadores" },
  { to: "/logs", icon: ListChecks, label: "Logs", id: "nav-logs" },
];

export default function Layout() {
  const navigate = useNavigate();
  const user = getUser();
  const logout = () => { clearAuth(); navigate("/login"); };

  return (
    <div className="flex min-h-screen bg-[#F8FAFC]">
      <aside className="w-[260px] shrink-0 bg-[#0F172A] text-white flex flex-col" data-testid="sidebar">
        <div className="px-5 py-6 border-b border-white/10">
          <img src={LOGO_URL} alt="Atlantic4Web" className="h-10 object-contain" />
        </div>
        <nav className="p-4 flex-1 space-y-1">
          {links.map(l => (
            <NavLink key={l.to} to={l.to} data-testid={l.id}
              className={({isActive}) => `a4w-sidebar-link ${isActive ? "active" : ""}`}>
              <l.icon size={18} />
              <span>{l.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10 space-y-1">
          <NavLink to="/conta" className="a4w-sidebar-link" data-testid="nav-conta">
            <User size={18} />
            <span className="truncate">{user?.name || "Conta"}</span>
          </NavLink>
          <button onClick={logout} data-testid="logout-btn"
            className="a4w-sidebar-link w-full text-left">
            <LogOut size={18} />
            <span>Terminar Sessão</span>
          </button>
        </div>
      </aside>
      <main className="flex-1 min-w-0 px-8 py-8">
        <Outlet />
      </main>
    </div>
  );
}
